export default "/build/images/elichens-logo-1200px.96477022.png";